<template>
  <div class="mb-5">
    {{ $t("components.login.LoginCardPasswordRequirementList.title") }}
    <div v-for="(requirement, index) in requirementList" :key="index">
      <div class="satisfiedRequirement" v-if="requirement.test && password">{{ working }} {{ requirement.text }}</div>
      <div class="unsatisfiedRequirement" v-if="!requirement.test && password">{{ fail }} {{ requirement.text }}</div>
      <div class="unsatisfiedRequirement smallfont" v-if="!requirement.test && password && index === 4">
        {{ specialCharacters }}
      </div>
      <div v-if="!requirement.test && !password">- {{ requirement.text }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  checkMinLength,
  containsCapitalLatinLetter,
  containsLowerLatinLetter,
  containsNumber,
  containsSpecialCharacter,
  getSpecialCharsList
} from "@/lib/passwordValidator";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoginComponentPasswordRequirementList extends Vue {
  @Prop()
  password!: string;

  @Prop()
  setPass!: Function;

  fail = "✘";

  working = "✔";

  specialCharacters = getSpecialCharsList();

  setIsAllCorrect(reqs: any[]) {
    if (this.setPass) {
      let correct = true;
      reqs.forEach((req) => {
        correct = correct && req.test;
        if (!correct) {
          return correct;
        }
      });
      this.setPass(correct);
    }
  }

  get requirementList() {
    const reqs = [
      {
        test: checkMinLength(this.password),
        text: this.$t("components.login.LoginCardPasswordRequirementList.minLength")
      },
      {
        test: containsCapitalLatinLetter(this.password),
        text: this.$t("components.login.LoginCardPasswordRequirementList.upperCase")
      },
      {
        test: containsLowerLatinLetter(this.password),
        text: this.$t("components.login.LoginCardPasswordRequirementList.lowerCase")
      },
      {
        test: containsNumber(this.password),
        text: this.$t("components.login.LoginCardPasswordRequirementList.number")
      },
      {
        test: containsSpecialCharacter(this.password),
        text: this.$t("components.login.LoginCardPasswordRequirementList.specialCharacter")
      }
    ];
    this.setIsAllCorrect(reqs);
    return reqs;
  }
}
</script>

<style>
.unsatisfiedRequirement {
  color: red;
}
.satisfiedRequirement {
  color: green;
}
.smallfont {
  font-size: 90%;
}
</style>
